<template>
    <div>
        <div class="loading" v-show="!loadFinished">
          <div class="az-loadingg-page">
            <h1 class="loading-title">Carregando Manual...</h1>
            <div class="loader"></div>
          </div>
        </div>
        <iframe v-show="loadFinished" class="manual-box" id="box-fornecedor" title="manual"
                src="https://manualize.com.br/categoria_licitacao/fornecedor/"
                @load="manualCarregado"/>
    </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'ManualLicitacaoLicitante',
    data() {
        return {
            menuAnteriorRetraido: false,
            loadFinished: false
        }
    },
    computed: {
        ...mapState(['loki']),
    },
    mounted() {
        this.menuAnteriorRetraido = this.$store.state.loki.asideClosed
        this.$store.state.loki.asideClosed = true
    },
    beforeDestroy(){
        this.$store.state.loki.asideClosed = this.menuAnteriorRetraido
    },
    methods:{
      manualCarregado(){
        this.loadFinished = true
      }
    }
}
</script>

<style scoped lang="stylus">
    iframe
        border 0px
        margin-left 0px
        height 1100px
        margin-top 0px
        width 100%
</style>
